import { http } from 'interfaces'
import { type QuerySaved, type QuerySavedFilters } from 'components'

export interface QuerySavedResults {
  data: QuerySaved[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}
export async function querySavedListFilter (params: QuerySavedFilters): Promise<QuerySavedResults> {
  return await http.get('api/v1/queries-saved/', {
    params: { ...params }
  }).then(value => value.data)
    .catch(reason => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}
